export default __webpack_public_path__ + "static/media/change-photo.b762334c.svg";